export const ignoredModules = new Set([
  "child_process",
  "cluster",
  "domain",
  "inspector",
  "inspector/promises",
  "punycode",
  "readline",
  "readline/promises",
  "repl",
  "node:sea",
  "node:test",
  "node:test/reporters",
  "tty",
  "v8",
  "vm",
  "wasi",
  "worker_threads",
]);
